/**
 * 瀑布图辅助类
 */
export default class WaterfallHelper {
  /**
   * 瀑布图的实现基于堆叠柱状图
   *
   * * 此方法用来将绘制瀑布图的数据集转换为堆叠柱状图数据集
   * ! 为了实现跨 0 轴的效果，需要将最小值调整为 0，即出现负值时整体向正向偏移
   */
  // eslint-disable-next-line sonarjs/cognitive-complexity
  static transformDataset(dataset: (number | { value: number; __segmentStart?: boolean })[][]) {
    /** 分段瀑布图，默认全段为一个完整的瀑布图 */
    const waterfallChartSegmentation = [0, dataset[0].length - 1];
    const result = dataset.map(data =>
      data.map((item, index) => {
        let tempItem = item;
        if (typeof tempItem === 'number') {
          tempItem = { value: tempItem };
        }
        if (tempItem.__segmentStart === true) {
          waterfallChartSegmentation.splice(waterfallChartSegmentation.length - 1, 0, index);
        }

        return {
          ...tempItem,
          __sign: tempItem.value >= 0 ? '' : '-',
          __originValue: tempItem.value,
          value: Math.abs(tempItem.value)
        };
      })
    );

    let segmentIndex = 0;

    // * 1. 将所有瀑布图系列数据集调整为堆叠柱状图数据集
    /** 堆叠瀑布图系列 */
    const tempSeriesArray = Array.from(Array(result.length), () => 0);
    let total = 0;
    let min = Infinity;

    result[0].forEach((item, index) => {
      // 瀑布图分段起始点，重置累加逻辑
      if (index === waterfallChartSegmentation[segmentIndex]) {
        // eslint-disable-next-line thsjs/no-redundant-assignments
        total = 0;
      }

      // 瀑布图分段末尾点，求和
      if (index === waterfallChartSegmentation[segmentIndex + 1]) {
        segmentIndex += 1;

        // 结果值：求和
        result[0][index].__sign = total >= 0 ? '' : '-';
        result[0][index].value = Math.abs(total);
      } else {
        // 堆叠瀑布图累加逻辑
        tempSeriesArray.forEach((_, indexArray) => {
          total += result[indexArray][index].__originValue;
        });
      }

      min = Math.min(min, Number(total.toFixed(2)));
    });

    // 堆叠瀑布图的最后求和柱子仅需要一个系列
    tempSeriesArray.slice(1).forEach((_, index) => {
      result[index + 1][result[index + 1].length - 1].value = 0;
    });

    // 出现负值后，为了让柱子能实现跨 0 刻度的效果，需要将最小值调整为 0
    const baseHeight = min < 0 ? -min : 0;

    // * 2. 计算第一个用来撑高瀑布图的堆叠柱系列
    // 添加一个堆叠柱状图的系列数据，用来撑高瀑布图
    const baseSeries = [] as typeof result[number];

    // eslint-disable-next-line thsjs/no-redundant-assignments
    segmentIndex = 0;

    result[0].forEach((item, index) => {
      let itemTemp = 0;

      // 瀑布图分段起始点，重置累加逻辑
      if (index === waterfallChartSegmentation[segmentIndex]) {
        total = baseHeight;
      }

      // 瀑布图分段末尾点，求和
      if (index === waterfallChartSegmentation[segmentIndex + 1]) {
        segmentIndex += 1;

        itemTemp = total - baseHeight;
        total = baseHeight;
      } else {
        // 堆叠瀑布图累加逻辑
        tempSeriesArray.forEach((_, indexArray) => {
          itemTemp += result[indexArray][index].__originValue;
        });
      }

      const height = itemTemp < 0 ? total : total + itemTemp;
      // 总高度 - 柱子高度 = 用来撑高的柱子高度
      const value = Number((height - Math.abs(itemTemp)).toFixed(2));

      baseSeries[index] = {
        __sign: '',
        __originValue: 0,
        value
      };

      // 瀑布图的累加逻辑
      // eslint-disable-next-line thsjs/no-redundant-assignments
      total += itemTemp;
    }, 0);

    result.unshift(baseSeries);

    return { dataset: result, baseHeight };
  }
}
